import React from 'react';

// During a hand we only show the overall MATCH score (points toward 11).
// Capture details (cards taken, denari, settebello, running scope tally) are
// intentionally hidden to keep the table like a real Scopa game — the engine
// still tracks everything internally for the end-of-hand scoring.
export default function ScorePanel({ state, youLabel = 'Tu', opponentLabel = 'Avversario' }) {
  return (
    <div className="w-full" data-testid="score-panel">
      <div
        className="w-full rounded-xl bg-[#2C1A14]/80 border border-[#D4AF37]/25 px-3 py-2"
        tabIndex={0}
        aria-label={`Punteggio partita. ${youLabel} ${state.matchScores.player}. ${opponentLabel} ${state.matchScores.cpu}. Si vince a 11.`}
        data-testid="match-score"
      >
        <div className="flex items-center justify-between">
          <span className="font-sans text-xs uppercase tracking-[0.12em] text-[#E0E0D1]/80">
            {youLabel}
          </span>
          <span className="font-serif text-2xl font-bold text-[#D4AF37]">
            {state.matchScores.player}
          </span>
        </div>
        <div className="flex items-center justify-between mt-0.5">
          <span className="font-sans text-xs uppercase tracking-[0.12em] text-[#E0E0D1]/80">
            {opponentLabel}
          </span>
          <span className="font-serif text-2xl font-bold text-[#FDFBF7]">
            {state.matchScores.cpu}
          </span>
        </div>
      </div>
    </div>
  );
}
